/**
 * /superadmin — SuperAdmin overview (route shell).
 *
 * The overview reads live platform metrics via `useSuperadminTenants`
 * (lib/api/superadmin) — the old `lib/fake-data/superadmin` fixtures were
 * deleted in Batch 17 (2026-05-20). The surface is still gated by
 * VITE_SUPERADMIN_ENABLED (see ./_layout.tsx) as a deploy-promotion safety
 * net for the destructive operator actions, NOT because of any fake data.
 *
 * Screen impl in `./index-screen.tsx`, lazy-loaded to keep the operator
 * surface out of the initial bundle.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/superadmin/')({
  component: lazyRouteComponent(
    () => import('./index-screen'),
    'SuperAdminOverview',
  ),
});
